import { PaginatedResponse } from '@/types';

const ALL_PAGE_SIZE = 100;
const MAX_PAGES = 50;

export async function loadAllPages<T>(
  fetchPage: (params: { page: number; pageSize: number }) => Promise<PaginatedResponse<T>>
): Promise<T[]> {
  const allItems: T[] = [];
  let page = 1;
  let totalCount = Number.POSITIVE_INFINITY;
  while (page <= MAX_PAGES && allItems.length < totalCount) {
    const data = await fetchPage({ page, pageSize: ALL_PAGE_SIZE });
    const items = data.items || [];
    totalCount = Number(data.totalCount || 0);
    if (!items.length) break;
    allItems.push(...items);
    page += 1;
  }
  return allItems;
}
